﻿import { useNavigate } from "react-router-dom";
import { FileSpreadsheet, ClipboardList } from "lucide-react";
import CustomTitle from "@/components/desktop/list/title/CustomTitle";
import styles from "./planning-home.module.scss";

const PlanningHome = () => {
	const navigate = useNavigate();

	const planningOptions = [
		{
			id: 1,
			title: "Planificación Fitosanitaria",
			description: "Gestiona tus programas fitosanitarios y genera órdenes de aplicación",
			icon: FileSpreadsheet,
			path: "/planificacion/programa_fitosanitario",
			color: "#7fb02f",
		},
		{
			id: 2,
			title: "Órdenes de Aplicación",
			description: "Administra y consulta las órdenes de aplicación generadas",
			icon: ClipboardList,
			path: "/ordenes_aplicacion",
			color: "#2196F3",
		},
	];

	const handleNavigate = (path) => {
		navigate(path);
	};

	return (
		<div>
			<CustomTitle
				title={[
					{ label: "Dashboard", onClick: () => navigate("/") },
					{ label: "Planificación", onClick: () => navigate("/planificacion") },
				]}
				subtitle="Selecciona una opción para continuar"
			/>

			<div className={styles.container}>
				<div className={styles.grid}>
					{planningOptions.map((option) => {
						const Icon = option.icon;
						return (
							<button
								key={option.id}
								className={styles.card}
								onClick={() => handleNavigate(option.path)}
								style={{ "--card-color": option.color }}
							>
								<div className={styles.iconContainer}>
									<Icon size={48} strokeWidth={1.5} />
								</div>
								<h3 className={styles.title}>{option.title}</h3>
								<p className={styles.description}>{option.description}</p>
							</button>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default PlanningHome;
